import axios from "axios";

export function fetchVoucherListing({ uuid, page, length, search, searchBy, startDate, endDate, status }) {
  return new Promise((resolve, reject) => {
    axios.get(`/consumer/admin/api/v1/survey/${uuid}/vouchers`,{
      params: {
        start: page * length,
        length,
        search,
        start_date: startDate,
        end_date: endDate,
        status,
        search_by: searchBy,
      }
    })
      .then(response => resolve(response.data))
      .catch(error => reject(error.response.data))
  })
}